import React, {useState} from 'react';
import {doPostTestDish} from "../../logic/dish";
import {useTranslation} from "react-i18next";
import {useDish} from "../../utils/contexts/dish-context";
import Button from "../UI/Button";
import BaseInput from "../UI/BaseInput";
import Loading from "../UI/Loading";
import Description from "../UI/Text/Description";
import {useApi} from "../../utils/hooks/api";

const DishNameInput = () => {

    const {setDish} = useDish();
    const {t, i18n} = useTranslation();
    const {call, loading} = useApi();

    const {inputDishName, setInputDishName} = useDish()
    const {inputDishDescription, setInputDishDescription} = useDish()

    const handleSubmit = async (e) => {
        e.preventDefault();

        await call(
            () => doPostTestDish(inputDishName, i18n.language, inputDishDescription),
            (res) => {
                if (res && res.data)
                    setDish(res.data);
            }
        )
    }

    return (
        <div>
            <Description>{t('calculate_impact.dish_input_text')}</Description>
            <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
                <div className="flex flex-col gap-2 w-full">
                    <BaseInput className="w-full"
                               placeholder={t('calculate_impact.dish_input_placeholder')}
                               value={inputDishName}
                               required={true}
                               onChange={(e) => setInputDishName(e.currentTarget.value)}/>
                    {i18n.language === 'ja' && (
                        <BaseInput className="w-full"
                                   placeholder={t('calculate_impact.dish_description_placeholder', 'Dish description')}
                                   value={inputDishDescription}
                                   onChange={(e) => setInputDishDescription(e.currentTarget.value)}/>
                    )}
                </div>
                {loading ? <Loading label="Computing..."/>
                    : <Button type='submit' className="sm:w-max">{t('calculate_impact.dish_input_button')}</Button>
                }
            </form>
        </div>
    );
};

export default DishNameInput;
